import firebase from 'firebase'

const config = {
    apiKey: "AIzaSyCxY5M05R-eR5zf7jH-lEo4B79XStnu4e8",
    authDomain: "health-lab-7f786.firebaseapp.com",
    databaseURL: "https://health-lab-7f786.firebaseio.com",
    projectId: "health-lab-7f786",
    storageBucket: "gs://health-lab-7f786.appspot.com/",
    messagingSenderId: "1018953209711",
    appId: "1:1018953209711:web:5ac8d6d635b77b5b1b3a9a"
  }
firebase.initializeApp(config);
  export default firebase;